import { RequestMethod, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ApiRequestOptions } from '../../../core/services/api/request-options';
import { JobDataApiFacade } from '../job-data/job-data.api-facade';
import { File } from './file.model';

export class FileApiFacade extends JobDataApiFacade<File> {

    get(accountId: string, jobId: string, id: string, options?: ApiRequestOptions): Observable<File> {
        return this.GET(`/accounts/${accountId}/jobs/${jobId}/files/${id}`, options)
            .map(object => new File(object));
    }

    getAll(accountId: string, jobId: string, options?: ApiRequestOptions): Observable<Array<File>> {
        return this.CGET(`/accounts/${accountId}/jobs/${jobId}/files`, options)
            .map(objects => objects.map(object => new File(object)));
    }

    getByJob(accountId: string, jobId: string, options?: ApiRequestOptions): Observable<Array<File>> {
        return this.CGET(`/accounts/${accountId}/jobs/${jobId}/files`, options)
            .map(objects => objects.map(object => new File(object)));
    }

    /**
     * This method fetches the binary content of the file from the api and
     * returns it to the caller as a Blob
     *
     * This method should only be used for small files. Larger files >5MB may
     * crash the mobile app.
     *
     * @param file {File}
     * @return {Observable<Blob>}
     */
    getFileContent(file: File): Observable<Blob> {

        const request = this.appFacade.api.createRequest(true, `/accounts/${file.account}/jobs/${file.job}/files/${file.id}/content`, RequestMethod.Get);

        request.appendHeader('Content-type', file.mimeType);
        request.setResponseType(ResponseContentType.Blob);

        return request.execute()
            .map(response => response.blob())
            .catch(error => {
                console.error('error retrieving file content', error);
                return Observable.throw(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/file/file.api-facade.ts